import { ReactComponent as Adyen } from './assets/Adyen.svg';
import { ReactComponent as Stripe } from './assets/Stripe.svg';
import { ReactComponent as PCI } from './assets/PCI.svg';
import { ReactComponent as SSL } from './assets/SSL.svg';
import { ReactComponent as GDPR } from './assets/GDPR.svg';
import SwitchLg from 'components/SwitchLg';
import Grid from '@material-ui/core/Grid';
import { PROVIDER } from 'constants/enum/type';
import { Container, LogoContent, Wrapper } from './index.view';

type FooterProps = {
  provider?: string;
};

const Footer = ({ provider }: FooterProps) => {
  const DisplayProviderIcon = () => {
    switch (provider) {
      case PROVIDER.ADYEN:
        return <Adyen />;
      case PROVIDER.STRIPE:
        return <Stripe />;
      default:
        return null;
    }
  };
  return (
    <Wrapper>
      <Container>
        <Grid container>
          <LogoContent item xs={8}>
            <DisplayProviderIcon />
            <PCI />
            <SSL />
            <GDPR />
          </LogoContent>
          <Grid item xs={4} style={{ textAlign: 'right' }}>
            <SwitchLg />
          </Grid>
        </Grid>
      </Container>
    </Wrapper>
  );
};
export default Footer;
